export default function ColorSelector({ colors, selected, onChange }) {
  return (
    <div>
      <p className="mb-3 text-sm font-medium">Color: {selected}</p>
      <div className="flex gap-2" role="radiogroup" aria-label="Select color">
        {colors.map((color) => (
          <button
            key={color.name}
            type="button"
            onClick={() => onChange(color.name)}
            aria-pressed={selected === color.name}
            className={`size-10 rounded-full border-2 focus:outline-none focus:ring-2 focus:ring-ring ${
              selected === color.name ? "border-foreground" : "border-border"
            }`}
            style={{ backgroundColor: color.value }}
          />
        ))}
      </div>
    </div>
  );
}